import {Directive, HostListener} from '@angular/core';
import {EditableComponent} from './editable.component';

@Directive({
    selector: '[editableOnEnter]',
    standalone: false
})
export class EditableOnEnterDirective {
  constructor(private editable: EditableComponent) {
  }

  @HostListener('keyup.enter')
  onEnter() {
    this.editable.toViewMode();
  }

}
